import Component from '../../../shared/component';

export default class AvatarBuilderClearOptionGroupButton extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);
    this.category = this.$element.data('category');

    this.avatarBuilder = opts.avatarBuilder;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on(
      'click.AvatarBuilderClearOptionGroupButton',
      this.handleClick
    );
  }

  unbindEvents() {
    this.$element.off(
      'click.AvatarBuilderClearOptionGroupButton',
      this.handleClick
    );
  }

  handleClick() {
    this.avatarBuilder.handleCategoryOptionReset(this.category);
  }

  markAsEnabled() {
    this.$element.removeClass('disabled');
  }

  markAsDisabled() {
    this.$element.addClass('disabled');
  }
}
